import { render } from "./DownloadPdfModal.vue?vue&type=template&id=2cf67994&scoped=true"
import script from "./DownloadPdfModal.vue?vue&type=script&lang=js"
export * from "./DownloadPdfModal.vue?vue&type=script&lang=js"

import "./DownloadPdfModal.vue?vue&type=style&index=0&id=2cf67994&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf67994"]])

export default __exports__